import Handsontable from 'handsontable'

const AutocompleteEditor = Handsontable.editors.AutocompleteEditor

class AutoCompleteObjectsEditor extends AutocompleteEditor {
  beginEditing(initialValue?: any, event?: Event): void {
    super.beginEditing(initialValue, event)
  }

  getValue(): any {
    const rawValue = this.getRawValue()

    return rawValue ? rawValue.name : null
  }

  getRawValue(): any {
    const choices: any[] = (this as any).rawChoices

    return choices.find(choice => this.TEXTAREA.value === choice.name)
  }

  setValue(newValue?: any): void {
    this.TEXTAREA.value = newValue
  }

  saveValue(value?: any, ctrlDown?: boolean): void {
    let selection: any[]
    let tmp // if ctrl+enter and multiple cells selected, behave like Excel (finish editing and apply to all cells)

    if (ctrlDown) {
      selection = this.hot.getSelectedLast() as any[]
      const [row, col, endRow, endCol] = selection

      if (row > endRow) {
        tmp = row
        selection[0] = endRow
        selection[2] = tmp
      }

      if (col > endCol) {
        tmp = col
        selection[1] = endCol
        selection[3] = tmp
      }
    } else {
      selection = [this.row, this.col, null, null]
    }

    const [row, col, endRow, endCol] = selection as any[]
    const nestedPropName = this.hot.getCellMeta(row, col).prop as string
    const rootPropName = nestedPropName.split('.').shift()

    this.hot.populateFromArray(row, col, value, endRow, endCol, 'edit')
    const rawData = this.getRawValue()

    if (typeof rawData === 'object') {
      Object.entries(rawData)
        .filter(([key]) => key !== 'name')
        .forEach(([key, value]) => {
          this.hot.setDataAtRowProp(
            row,
            `${rootPropName}.${key}`,
            value,
            'edit'
          )
        })
    }
  }

  queryChoices(query?: string): void {
    const source = this.cellProperties.source as any[] | Function
    const instance = this as any
    instance.query = query

    if (typeof source === 'function') {
      source.call(
        instance.cellProperties,
        query as string,
        (choices: any[]) => {
          instance.rawChoices = choices
          instance.updateChoicesList(choices.map(choice => choice.name))
        }
      )
    } else if (Array.isArray(source)) {
      instance.rawChoices = source
      instance.updateChoicesList(source.map(choice => choice.name))
    } else {
      instance.updateChoicesList([])
    }
  }
}

Handsontable.cellTypes.registerCellType('autocomplete-objects', {
  editor: AutoCompleteObjectsEditor,
  renderer: Handsontable.renderers.AutocompleteRenderer,
})
